import { render, staticRenderFns } from "./Relatorios.vue?vue&type=template&id=12004278&scoped=true"
import script from "./Relatorios.vue?vue&type=script&lang=js"
export * from "./Relatorios.vue?vue&type=script&lang=js"
import style0 from "./Relatorios.vue?vue&type=style&index=0&id=12004278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12004278",
  null
  
)

export default component.exports